import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  const displayCategories = categories.filter((c) => c.id !== 'all');

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            按题材筛选，找到你喜欢的漫画类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {displayCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-6 rounded-xl bg-background-50 hover:bg-primary-500 transition-all duration-300"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-background-100 group-hover:bg-background-50/20 flex items-center justify-center transition-colors">
                <i className={`${cat.icon} text-2xl text-foreground-700 group-hover:text-background-50 transition-colors`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-background-50 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}